import React, { Component } from "react";
import { connect } from "react-redux";
import "./ShopLiveChat.scss";
import axios from "axios";
import moment from 'moment';


class ShopLiveChat extends Component {
    constructor(props) {
        super(props);
        this.showLocationLoadingTimer = null;

        this.state = {
            status: "branch",
            searchText: "",
            selectedBranchId: "",
            justToggledId: null,
            favoriteBranches: [],
            allBranches: [],
            selectedBranch: null,
            serviceDesc: [],
            selectedService: null,
            isLoadingBranches: true,
            isSortingByLocation: false,
            hasAskedLocationAfterLoad: false,
            shouldShowLocationLoading: false,
            specialDate: [],
        };
    }

    // componentDidMount() {
    //     const currentUid = this.props.profile?.userId;
    //     if (currentUid) {
    //         this.initializeBranches(currentUid);
    //     }

    //     this.refreshTimer = setInterval(async () => {
    //         if (this.state.status === "service-menu" && this.state.selectedBranch) {
    //             await this.refreshSelectedBranch();
    //         }
    //     }, 120000);// 2 นาที
    // }

    componentDidUpdate(prevProps) {
        const prevUid = prevProps.profile?.userId;
        const currentUid = this.props.profile?.userId;

        if (currentUid && prevUid !== currentUid) {
            this.initializeBranches(currentUid);
        }
    }
    componentWillUnmount() {
        if (this.showLocationLoadingTimer) {
            clearTimeout(this.showLocationLoadingTimer);
            this.showLocationLoadingTimer = null;
        }
        if (this.refreshTimer) {
            clearInterval(this.refreshTimer);
            this.refreshTimer = null;
        }
    }
    getCurrentPosition = () =>
        new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                reject(new Error("Geolocation not supported"));
                return;
            }

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    // console.log("geolocation success:", position);
                    resolve({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    });
                },
                (error) => {
                    // console.log("geolocation error:", {
                    //     code: error?.code,
                    //     message: error?.message,
                    // });
                    reject(error);
                },
                {
                    enableHighAccuracy: false,
                    timeout: 15000,
                    maximumAge: 300000,
                }
            );
        });

    getDistanceKm = (lat1, lon1, lat2, lon2) => {
        const toRad = (value) => (value * Math.PI) / 180;
        const R = 6371;

        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);

        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) *
            Math.cos(toRad(lat2)) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    };

    sortBranchesByDistance = (branches, currentLocation) => {
        if (!currentLocation) return [...branches];

        return branches
            .map((branch) => {
                const branchLat = parseFloat(branch.latitude);
                const branchLng = parseFloat(branch.longitude);

                const hasValidLocation =
                    !Number.isNaN(branchLat) && !Number.isNaN(branchLng);

                return {
                    ...branch,
                    distance: hasValidLocation
                        ? this.getDistanceKm(
                            currentLocation.latitude,
                            currentLocation.longitude,
                            branchLat,
                            branchLng
                        )
                        : Number.MAX_SAFE_INTEGER,
                };
            })
            .sort((a, b) => a.distance - b.distance);
    };

    mapBranchData = (items = [], favorite = [], specialDate = []) => {
        const favoriteSet = new Set(favorite || []);
        const todayStr = moment().format("YYYY-MM-DD");
        const nowTime = moment().format("HH:mm");

        const todaySpecial = specialDate.find(
            (item) => item.specialDay === todayStr
        );

        return items.map((item) => {
            const originalIsOpen = item.isOpen;
            const originalIsOutOfTime = item.isOutOfTime;

            if (!todaySpecial) {
                return {
                    id: item._id,
                    _id: item._id,
                    code: item.code || "",
                    nameTh: item.name?.split("|")[0]?.trim() || "",
                    nameEn: item.name?.split("|")[1]?.trim() || "",
                    fullName: item.name || "",
                    favorite: favoriteSet.has(item.code),
                    desc: item.desc || "",
                    desc_full: item.desc_full || "",
                    enable: item.enable,
                    latitude: item.latitude,
                    longitude: item.longitude,
                    departmentID: item.departmentID,
                    schedules: item.schedules || [],
                    serviceTypes: item.serviceTypes || [],
                    isOpen: originalIsOpen,
                    isOutOfTime: originalIsOutOfTime,
                };
            }

            const isInSpecialTime =
                todaySpecial.allDay ||
                (
                    nowTime >= todaySpecial.timeFrom &&
                    nowTime <= todaySpecial.timeTo
                );

            return {
                id: item._id,
                _id: item._id,
                code: item.code || "",
                nameTh: item.name?.split("|")[0]?.trim() || "",
                nameEn: item.name?.split("|")[1]?.trim() || "",
                fullName: item.name || "",
                favorite: favoriteSet.has(item.code),
                desc: item.desc || "",
                desc_full: item.desc_full || "",
                enable: item.enable,
                latitude: item.latitude,
                longitude: item.longitude,
                departmentID: item.departmentID,
                schedules: item.schedules || [],
                serviceTypes: item.serviceTypes || [],
                isOpen: isInSpecialTime,
                isOutOfTime: !isInSpecialTime,
            };
        });
    };

    splitFavoriteBranches = (branches = []) => {
        return {
            favoriteBranches: branches.filter((item) => item.favorite),
            allBranches: branches.filter((item) => !item.favorite),
        };
    };

    fetchServiceshops = async (uid) => {
        if (!uid) {
            this.setState({
                favoriteBranches: [],
                allBranches: [],
                serviceDesc: [],
                specialDate: [],
            });

            return {
                mapped: [],
                favoriteBranches: [],
                allBranches: [],
                serviceDesc: [],
                specialDate: [],
            };
        }

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/serviceshop`,
                {
                    params: { uid },
                }
            );

            const items = response?.data?.data || [];
            const favorite = response?.data?.favorite || [];
            const serviceDesc = (response?.data?.serviceDesc || []).filter(
                (item) => item.enable === true
            );
            const specialDate = response?.data?.specialDate || [];

            const mapped = this.mapBranchData(items, favorite, specialDate);
            const { favoriteBranches, allBranches } = this.splitFavoriteBranches(mapped);

            this.setState({
                favoriteBranches,
                allBranches,
                serviceDesc,
                specialDate,
            });

            return {
                mapped,
                favoriteBranches,
                allBranches,
                serviceDesc,
                specialDate,
            };
        } catch (err) {
            console.error("fetchServiceshops error", err);

            this.setState({
                favoriteBranches: [],
                allBranches: [],
                serviceDesc: [],
                specialDate: [],
            });

            return {
                mapped: [],
                favoriteBranches: [],
                allBranches: [],
                serviceDesc: [],
                specialDate: [],
            };
        }
    };

    fetchBranches = async (uid) => {
        const result = await this.fetchServiceshops(uid);
        return result.mapped;
    };

    initializeBranches = async (uid) => {
        try {
            this.setState({
                isLoadingBranches: true,
                hasAskedLocationAfterLoad: false,
            });

            const mapped = await this.fetchBranches(uid);

            this.setState({ isLoadingBranches: false });
            await this.askLocationAndResort(mapped);
        } catch (err) {
            console.error("initializeBranches error:", err);
            this.setState({
                isLoadingBranches: false,
            });
        }
    };

    askLocationAndResort = async (branchListFromFetch = null) => {
        try {
            const { hasAskedLocationAfterLoad, favoriteBranches, allBranches } = this.state;

            if (hasAskedLocationAfterLoad) return;

            const sourceList =
                branchListFromFetch && branchListFromFetch.length > 0
                    ? branchListFromFetch
                    : [...favoriteBranches, ...allBranches];

            if (sourceList.length === 0) {
                return;
            }

            // console.log("askLocationAndResort start");

            this.setState({
                hasAskedLocationAfterLoad: true,
                isSortingByLocation: true,
                shouldShowLocationLoading: false,
            });

            if (this.showLocationLoadingTimer) {
                clearTimeout(this.showLocationLoadingTimer);
                this.showLocationLoadingTimer = null;
            }

            this.showLocationLoadingTimer = setTimeout(() => {
                this.setState({ shouldShowLocationLoading: true });
            }, 500);

            const currentLocation = await this.getCurrentPosition();

            if (this.showLocationLoadingTimer) {
                clearTimeout(this.showLocationLoadingTimer);
                this.showLocationLoadingTimer = null;
            }

            const sorted = this.sortBranchesByDistance(sourceList, currentLocation);
            const { favoriteBranches: nextFavorite, allBranches: nextAll } =
                this.splitFavoriteBranches(sorted);

            this.setState({
                favoriteBranches: nextFavorite,
                allBranches: nextAll,
                isSortingByLocation: false,
                shouldShowLocationLoading: false,
            });
        } catch (error) {
            if (this.showLocationLoadingTimer) {
                clearTimeout(this.showLocationLoadingTimer);
                this.showLocationLoadingTimer = null;
            }

            console.warn("askLocationAndResort error:", {
                code: error?.code,
                message: error?.message,
            });

            this.setState({
                isSortingByLocation: false,
                shouldShowLocationLoading: false,
            });
        }
    };

    handleSearch = (e) => {
        this.setState({ searchText: e.target.value });
    };

    handleSelectBranch = (id) => {
        this.setState({ selectedBranchId: id });
    };

    handleToggleFavorite = (branch) => {
        this.setState(
            (prevState) => {
                const isFavorite = prevState.favoriteBranches.some(
                    (item) => item.id === branch.id
                );

                if (isFavorite) {
                    const updatedFavorite = prevState.favoriteBranches.filter(
                        (item) => item.id !== branch.id
                    );

                    const movedItem = { ...branch, favorite: false };
                    const existsInAll = prevState.allBranches.some(
                        (item) => item.id === branch.id
                    );

                    return {
                        justToggledId: branch.id,
                        favoriteBranches: updatedFavorite,
                        allBranches: existsInAll
                            ? prevState.allBranches
                            : [movedItem, ...prevState.allBranches],
                    };
                }

                const updatedAll = prevState.allBranches.filter(
                    (item) => item.id !== branch.id
                );
                const movedItem = { ...branch, favorite: true };

                const existsInFavorite = prevState.favoriteBranches.some(
                    (item) => item.id === branch.id
                );

                return {
                    justToggledId: branch.id,
                    favoriteBranches: existsInFavorite
                        ? prevState.favoriteBranches
                        : [movedItem, ...prevState.favoriteBranches],
                    allBranches: updatedAll,
                };
            },
            () => {
                if (this.branchContentRef) {
                    this.branchContentRef.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                }

                setTimeout(() => {
                    this.setState({ justToggledId: null });
                    this.saveFavoriteBranches();
                }, 700);
            }
        );
    };

    saveFavoriteBranches = async () => {
        try {
            const { favoriteBranches } = this.state;
            const uid = this.props.profile?.userId;

            if (!uid) return;

            const fav = favoriteBranches.map((item) => item.code).filter(Boolean);
            // if (!fav.length) return;
            await axios.post(
                `${process.env.REACT_APP_API_URL}/serviceshop/favorite`,
                { uid, fav }
            );
        } catch (err) {
            console.error("saveFavoriteBranches error:", err);
        }
    };

    handleConfirmBranch = async () => {
        const { selectedBranchId } = this.state;
        const currentUid = this.props.profile?.userId;

        if (!selectedBranchId) return;

        const { favoriteBranches, allBranches } = await this.fetchServiceshops(currentUid);
        const allList = [...favoriteBranches, ...allBranches];

        const selectedBranch = allList.find(
            (item) => item._id === selectedBranchId || item.id === selectedBranchId
        );

        this.setState({
            status: "service-menu",
            selectedBranch,
            selectedService: null,
        });
    };

    refreshSelectedBranch = async () => {
        const { selectedBranch } = this.state;
        const currentUid = this.props.profile?.userId;

        if (!currentUid || !selectedBranch?._id) return null;

        const { favoriteBranches, allBranches } = await this.fetchServiceshops(currentUid);
        const allList = [...favoriteBranches, ...allBranches];

        const latestSelectedBranch = allList.find(
            (item) => item._id === selectedBranch._id || item.id === selectedBranch.id
        );

        if (latestSelectedBranch) {
            this.setState({
                selectedBranch: latestSelectedBranch,
            });
        }

        return latestSelectedBranch;
    };

    handleSelectService = async (service) => {
        const latestBranch = await this.refreshSelectedBranch();

        if (!latestBranch?.enable || !latestBranch?.isOpen) {
            return;
        }

        const latestServiceType = (latestBranch.serviceTypes || []).find(
            (item) => item._id === service._id
        );

        const { serviceDesc, specialDate } = this.state;

        const todayStr = moment().format("YYYY-MM-DD");
        const todaySpecial = (specialDate || []).find(
            (item) => item.specialDay === todayStr
        );

        // ถ้าไม่ใช่วัน specialDate ให้ใช้ logic service เดิม
        if (!todaySpecial && latestServiceType?.isOpen === false) {
            return;
        }

        const latestServiceInfo = serviceDesc.find(
            (desc) => desc._id === service._id && desc.enable === true
        );

        this.setState({
            selectedService: latestServiceInfo
                ? {
                    ...latestServiceInfo,
                    schedules: latestServiceType?.schedules || [],
                    isOpen: todaySpecial
                        ? latestBranch?.isOpen === true
                        : latestServiceType?.isOpen !== undefined
                            ? latestServiceType.isOpen
                            : true,
                }
                : null,
        });
    };

    handleBackFromServiceDetail = () => {
        this.setState({
            selectedService: null,
        });
    };

    handleCloseServicePage = async () => {
        this.setState(
            {
                status: "branch",
                selectedService: null,
                selectedBranch: null,
                selectedBranchId: "",
                hasAskedLocationAfterLoad: false,
            },
            async () => {
                const { favoriteBranches, allBranches } = this.state;
                await this.askLocationAndResort([...favoriteBranches, ...allBranches]);
            }
        );
    };

    handleCancelCode = () => {
        if (window.liff && typeof window.liff.closeWindow === "function") {
            window.liff.closeWindow();
        } else {
            window.close();
        }
    };

    handleConfirmService = async () => {
        const { selectedBranch, selectedService } = this.state;

        if (!selectedService) return;

        const currentUid = this.props.profile?.userId;

        const payload = {
            uid: currentUid,
            dep_id: selectedBranch?._id || "",
            code: selectedBranch?.code || "",
            departmentID: selectedBranch?.departmentID || "",
            fullName: selectedBranch?.fullName || "",
            serviceName: selectedService?.name_display || "",
            fav: [],
        };

        console.log("ex10 payload:", payload);

        try {
            await axios.post(
                `${process.env.REACT_APP_API_URL}/serviceshop/ex10`,
                payload
            );

            const { favoriteBranches, allBranches } = this.state;
            const allList = [...favoriteBranches, ...allBranches];
            const refreshedSelectedBranch = allList.find(
                (item) => item._id === selectedBranch?._id
            );

            this.setState({
                selectedBranch: refreshedSelectedBranch || selectedBranch,
            });

            if (window.liff && typeof window.liff.closeWindow === "function") {
                window.liff.closeWindow();
            }
        } catch (err) {
            console.error(err);
        }
    };


    getAvailableServices = () => {
        const { serviceDesc, selectedBranch, specialDate } = this.state;
        const branchServiceTypes = selectedBranch?.serviceTypes || [];

        const todayStr = moment().format("YYYY-MM-DD");

        const todaySpecial = (specialDate || []).find(
            (item) => item.specialDay === todayStr
        );

        return branchServiceTypes
            .map((serviceType) => {
                const serviceInfo = serviceDesc.find(
                    (desc) => desc._id === serviceType._id && desc.enable === true
                );

                if (!serviceInfo) return null;

                return {
                    ...serviceInfo,
                    schedules: serviceType.schedules || [],
                    isOpen: todaySpecial
                        ? selectedBranch?.isOpen === true
                        : serviceType.isOpen !== undefined
                            ? serviceType.isOpen
                            : true,
                };
            })
            .filter(Boolean);
    };

    renderBranchCard = (branch, selected = false, showFavoriteIcon = true) => {
        const { justToggledId } = this.state;

        return (
            <div
                key={branch.id}
                className={`branch-card ${selected ? "selected" : ""} ${!branch.favorite ? "not-fav" : ""
                    } ${justToggledId === branch.id ? "just-toggled" : ""}`}
                onClick={() => this.handleSelectBranch(branch.id)}
            >
                <div className="branch-card-left">
                    <div className="branch-pin">
                        <img
                            src="/images/shoplivechat/shoplivechat-location.png"
                            alt="location"
                        />
                    </div>

                    <div className="branch-text">
                        <div className="branch-name-th">{branch.nameTh}</div>
                    </div>
                </div>

                {showFavoriteIcon && (
                    <button
                        type="button"
                        className={`favorite-btn ${branch.favorite ? "active" : ""}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            this.handleToggleFavorite(branch);
                        }}
                    >
                        <img
                            src={
                                branch.favorite
                                    ? "/images/shoplivechat/shoplivechat-fav-true.png"
                                    : "/images/shoplivechat/shoplivechat-fav-false.png"
                            }
                            alt="favorite"
                            className="favorite-icon"
                        />
                    </button>
                )}
            </div>
        );
    };
    renderBranchSkeleton = () => {
        return (
            <div className="branch-list all-list">
                {[...Array(8)].map((_, index) => (
                    <div key={index} className="branch-card skeleton">
                        <div className="branch-card-left">
                            <div className="branch-pin skeleton-box" />
                            <div className="branch-text">
                                <div className="skeleton-line short" />
                                <div className="skeleton-line long" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    };
    renderBranchSelector = () => {
        const {
            searchText,
            selectedBranchId,
            favoriteBranches,
            allBranches,
            isLoadingBranches,
        } = this.state;

        const keyword = searchText.trim().toLowerCase();

        const filterFn = (item) =>
            item.nameTh.toLowerCase().includes(keyword) ||
            item.nameEn.toLowerCase().includes(keyword);

        const filteredFavorite = favoriteBranches.filter(filterFn);
        const filteredAll = allBranches.filter(filterFn);

        return (
            <div className="shoplivechat fullscreen branch-page">
                <div className="branch-modal">
                    <div className="branch-header">
                        <div className="branch-header-title">ค้นหาสาขาแอมเวย์ช็อป</div>

                        {/* <button
                            className="icon-btn close-btn"
                            type="button"
                            onClick={this.handleCancelCode}
                        >
                            ×
                        </button> */}
                    </div>

                    <div className="branch-content-top">
                        <img
                            src="/images/shoplivechat/shoplivechat-top.png"
                            alt="branch header"
                            className="branch-header-figure"
                        />

                        <div className="search-box">
                            <span className="search-icon">⌕</span>
                            <input
                                type="text"
                                placeholder="ชื่อสาขา"
                                value={searchText}
                                onChange={this.handleSearch}
                                disabled={isLoadingBranches}
                            />
                        </div>
                    </div>

                    <div
                        className="branch-content"
                        ref={(el) => (this.branchContentRef = el)}
                    >
                        {/* {isLoadingBranches && (
                            <div className="service-empty">กำลังโหลดข้อมูลสาขา...</div>
                        )}

                        {!isLoadingBranches && shouldShowLocationLoading && (
                            <div className="service-empty">กำลังค้นหาสาขาใกล้คุณ...</div>
                        )} */}

                        {!isLoadingBranches && filteredFavorite.length > 0 && (
                            <>
                                <div className="section-header">
                                    <div className="section-title">สาขาที่ชื่นชอบ</div>
                                    <div className="section-count">{filteredFavorite.length} สาขา</div>
                                </div>

                                <div className="branch-list favorite-list">
                                    {filteredFavorite.map((item) =>
                                        this.renderBranchCard(
                                            item,
                                            selectedBranchId === item.id,
                                            true
                                        )
                                    )}
                                </div>
                            </>
                        )}


                        <>
                            <div className="section-header all-header">
                                <div className="section-title">สาขาทั้งหมด</div>
                                <div className="section-count">
                                    {isLoadingBranches ? "0 สาขา" : `${filteredAll.length} สาขา`}
                                </div>
                            </div>

                            {isLoadingBranches ? (
                                this.renderBranchSkeleton()
                            ) : (
                                <div className="branch-list all-list">
                                    {filteredAll.map((item) =>
                                        this.renderBranchCard(
                                            item,
                                            selectedBranchId === item.id,
                                            true
                                        )
                                    )}
                                </div>
                            )}
                        </>
                        <div className="branch-footer">
                            <button
                                type="button"
                                className={`confirm-btn ${!selectedBranchId ? "disabled" : ""}`}
                                onClick={this.handleConfirmBranch}
                                disabled={!selectedBranchId}
                            >
                                ยืนยัน
                            </button>
                        </div>
                    </div>


                </div>
            </div>
        );
    };

    renderServiceMenu = () => {
        const { selectedService, selectedBranch } = this.state;
        const availableServices = this.getAvailableServices();
        const isBranchAvailable =
            selectedBranch?.enable && selectedBranch?.isOpen;

        const closedMessage = !selectedBranch?.enable
            ? (selectedBranch?.desc || "ขออภัย ขณะนี้ปิดให้บริการ")
            : selectedBranch?.isOutOfTime
                ? (selectedBranch?.desc || "ขออภัย ขณะนี้ปิดให้บริการ")
                : (selectedBranch?.desc || "ขออภัย ขณะนี้ปิดให้บริการ");

        return (
            <div className="shoplivechat fullscreen branch-page">
                <div className="branch-modal">
                    <div
                        className="branch-header-service"
                        style={{ borderRadius: "22px 22px 0px 0px" }}
                    >
                        <div
                            className="branch-header-title"
                            onClick={() =>
                                selectedService
                                    ? this.handleBackFromServiceDetail()
                                    : this.handleCloseServicePage()
                            }
                        >
                            <span className="back-icon">‹</span>
                            <span className="title-text">
                                {selectedService
                                    ? selectedService.name_display
                                    : "แอมเวย์เซอร์วิส"}
                            </span>
                        </div>

                        {/* <button
                            className="icon-btn close-btn"
                            type="button"
                            onClick={this.handleCancelCode}
                        >
                            ×
                        </button> */}
                    </div>

                    <div className="service-content">
                        <div className="service-subtitle">
                            {selectedService ? (
                                selectedService.desc
                            ) : (
                                <>
                                    พร้อมให้บริการอย่างรวดเร็ว
                                    <br />
                                    ด้วยความใส่ใจ
                                </>
                            )}
                        </div>

                        {!selectedService ? (
                            !isBranchAvailable ? (
                                <>
                                    <div className="service-empty-false">
                                        {closedMessage}
                                    </div>

                                    {availableServices.length > 0 && (
                                        <div className="service-grid disabled">
                                            {availableServices.map((item) => (
                                                <button
                                                    key={item._id}
                                                    type="button"
                                                    className="service-card disabled"
                                                    disabled
                                                >
                                                    <img
                                                        src={`${process.env.REACT_APP_S3_URL}${item.pic}`}
                                                        alt={item.name_display}
                                                        className="service-card-icon"
                                                    />
                                                    <div className="service-card-title">
                                                        {item.name_display}
                                                    </div>
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="service-grid">
                                    {availableServices.length > 0 ? (
                                        availableServices.map((item) => (
                                            <button
                                                key={item._id}
                                                type="button"
                                                className={`service-card ${!item.isOpen ? 'disabled' : ''}`}
                                                onClick={() => item.isOpen && this.handleSelectService(item)}
                                                disabled={!item.isOpen}
                                            >
                                                <img
                                                    src={`${process.env.REACT_APP_S3_URL}${item.pic}`}
                                                    alt={item.name_display}
                                                    className="service-card-icon"
                                                />
                                                <div className="service-card-title">
                                                    {item.name_display}
                                                </div>
                                            </button>
                                        ))
                                    ) : (
                                        <div className="service-empty">
                                            ยังไม่มีบริการสำหรับสาขานี้
                                        </div>
                                    )}
                                </div>
                            )
                        ) : (
                            <div className="service-detail">
                                <div className="service-detail-title">รายละเอียด</div>

                                <div className="service-detail-desc">
                                    {selectedService?.desc_full || "-"}
                                </div>
                            </div>
                        )}

                        {selectedService && (
                            <div className="branch-footer">
                                <button
                                    type="button"
                                    className="confirm-btn"
                                    onClick={this.handleConfirmService}
                                >
                                    เลือก
                                </button>
                            </div>
                        )}
                    </div>

                    <img
                        src="/images/shoplivechat/shoplivechat-top.png"
                        alt="service header"
                        className="service-header-figure"
                    />


                </div>
            </div>
        );
    };

    render() {
        const { status } = this.state;

        return (
            <>
                <style></style>
                {status === "branch" && this.renderBranchSelector()}
                {status === "service-menu" && this.renderServiceMenu()}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    profile: state.profile,
});

export default connect(mapStateToProps)(ShopLiveChat);
